
import Vue from 'vue';
import CheckedIcon from '../../Icons/CheckedIcon.vue';
import { Spacer } from '../Spacings';
/**
 * Checkbox Component
 */
export default Vue.extend({
  name: 'Checkbox',
  components: {
    CheckedIcon,
    Spacer
  },
  inheritAttrs: false,
  props: {
    /**
     * Checked condition of checkbox.
     * @model
     */
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    /**
     * Disabled state of checkbox.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Error state of checkbox.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Required property.
     */
    required: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$attrs.id = this.$attrs.id || '';
    if (this.required) {
      /**
       * Handle error state for checkbox
       * @event inputState
       * @type {function}
       */
      this.$emit('inputState', this.value ? true : null);
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    handleChange(e: Event) {
      if (this.disabled) {
        return null;
      }
      this.$emit('inputState', (e.target as HTMLInputElement).checked);
      /**
       * Handle input change for checkbox
       * @event input
       * @type {function}
       */
      return this.$emit('input', (e.target as HTMLInputElement).checked);
    }
  }
});
